import React, { useEffect, useState } from 'react';
import {
    CircularProgress,
    Grid, Typography
} from "@material-ui/core/";
import { Link } from 'react-router-dom';
import { ModalHandle } from '../../../../../components/controls/Modal';
import TermsDeclarationsForm from '../../../../../forms/multiprofissional/TermsDeclarationsForm';
import FormBase from '../../../../../forms/FormBase';
import Controls from '../../../../../components/controls/Controls';
import TermsDeclarationsService from '../../../../../services/TermsDeclarationsService';
import TermsDeclarations from '../../../../../models/TermsDeclarations';
import TmpHtmlContentCustom from '../../../../../components/tempo/TmpHtmlContentCustom/TmpHtmlContentCustom';

interface AbsenceConflictDeclarationProps {
    Name: string;
    Crm: string;
    Specialty: string;
    TermsDeclarationsForm: TermsDeclarationsForm;
    onInputChange: (name: string, form: FormBase, value: any) => void
}

export default function AbsenceConflictDeclaration(props: AbsenceConflictDeclarationProps) {


    const modalRef = React.createRef<ModalHandle>();

    const handleOpenModalChild = () => {
        modalRef.current?.handleOpen()
    };

    const [text, setText] = useState<string>("")
    const [title, setTitle] = useState<string>("")
    const [id, setId] = useState<number>(0)
    const [checkedTerm, setCheckedTerm] = useState(props.TermsDeclarationsForm.AbsenceConflictDeclaration.Value.Checked);

    useEffect(() => {

        TermsDeclarationsService.getCurrentTermsDeclarations("DECL_AUSENCIA_CONFLITO_INTERESSE_2").then(e => {

            if (e) {
                var textTerm = e.description;

                textTerm = textTerm.replace("#{props.Name}", props.Name)
                textTerm = textTerm.replace("#{props.Crm}", props.Crm)
                textTerm = textTerm.replace("#{props.Especialidade}", props.Specialty)

                setText(textTerm)
                setTitle(e.title)
                setId(e.textId);
            }
        })

    }, [props.Name, props.Crm, props.Specialty])

    const handleCheckdTerm = (e: any) => {
        setCheckedTerm(e.target.value);
        props.onInputChange("AbsenceConflictDeclaration", props.TermsDeclarationsForm, new TermsDeclarations(id, e.target.value));
    }


    return (
        <Grid item xs={12} sm={12}>
            {
                id === undefined || id === 0 ?
                    <Grid container justifyContent="center" style={{ width: "85%" }} >
                        <CircularProgress />
                    </Grid>
                    :
                    <Controls.Checkbox
                        name="AbsenceConflictDeclaration"
                        labelComponent={
                            <div>
                                <span>Li e estou de acordo com a  </span>
                                <Link to={'#'} onClick={() => handleOpenModalChild()}>Declaração de Ausência de Conflito de Interesse.</Link>
                            </div>
                        }
                        value={checkedTerm}
                        onChange={handleCheckdTerm}
                    />
            }


            <Controls.Modal ref={modalRef} title={title}>

                <Typography variant="body1" gutterBottom component="div">
                    <TmpHtmlContentCustom html={text} />
                </Typography>

            </Controls.Modal>
        </Grid>
    );
}




